<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <div class="form-group">
          <label for="datepicker">Từ ngày - đến ngày</label>
          <DatePicker locale="vi" id="datepicker" v-model="dateRange" :model-config="dateRangeConfig" :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }" is-range class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="inputValue.start + ' - ' + inputValue.end"
                v-on="inputEvents.start"
                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                readonly
              />
            </template>
          </DatePicker>
        </div>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2">
        <BaseInput
          :options="titleInput.options"
          :data="titleInput.data"
          :listener="titleInput.listener"
        />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right; margin-left: 5px"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)"
            >
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #createDate="{ item }">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
            <td v-if="item.createDate == null"></td>
          </template>
          <template #level="{ item }">
            <td>
              <span class="badge badge-success" v-if="item.level == 0"
                >Bình thường</span
              >
              <span class="badge badge-warning" v-if="item.level == 1"
                >Ưu tiên</span
              >
              <span class="badge badge-danger" v-if="item.level == 2"
                >Khẩn cấp</span
              >
            </td>
          </template>
          <template #url="{ item }">
            <td>
              <span v-if="item.url" class="view-file" @click="viewFile(item.typeFile, item.url, item.contentFile)">Ấn vào để xem tệp</span>
              <!--              <audio class="audio-css" :src="convertUrl(item.url)" controls></audio>-->
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <CModal title="Nội dung tệp tin" :show.sync="isShowPopupContent" :closeOnBackdrop="false" size="lg">
      <CRow class="content-fade-in">
        <CCol md="12">
          <CForm class="form-basic">
            {{ contentDetail }}
          </CForm>
        </CCol>
      </CRow>
      <div slot="footer">
        <CButton color="secondary" class="btn-action-primary" @click="isShowPopupContent = false"><i
          class="fa fa-times"></i> Đóng
        </CButton>
      </div>
    </CModal>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import { ScreenHistoryType } from "../../../constant";
import BaseTable from "../../base/BaseDataTable";
import BaseInput from "../../base/BaseInput";
import BaseSelect from "../../base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import {DatePicker} from "v-calendar";

export default {
  name: "ScreenPlayingList",
  components: {
    BaseFormLoading,
    BaseTable,
    BaseInput,
    DatePicker
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    return {
      loading: { value: false },
      isShowPopupContent: false,
      contentDetail: "",
      dateRange: {
        start: new Date().setHours(0, 0, 0, 0),
        end: new Date().setHours(23, 59, 59, 999)
      },
      dateRangeConfig: {
        start: {
          timeAdjust: '00:00:00',
        },
        end: {
          timeAdjust: '23:59:59',
        },
      },
      titleInput: {
        options: {
          placeholder: "Tiêu đề tệp tin",
          label: "Tiêu đề tệp tin",
        },
        data: {
          name: "fileName",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      historyType: {
        data: {
          name: "historyType",
          model: ScreenHistoryType.DANG_PHAT,
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      mainTable: {
        options: {
          fields: [
            { key: "index", label: "STT" },
            { key: "fileName", label: "Tiêu đề", _style: "max-width:20%; width:20%" },
            { key: "createDate", label: "Thời gian phát" },
            { key: "level", label: "Cấp độ" },
            { key: "deviceCode", label: "Mã thiết bị phát" },
            { key: "url", label: "Tệp" },
          ],
          slots: ["index", "level", "createDate", "status", "url"],
        },
        dataSource: {
          url: "/screen-file-history/getPages",
          dataSubmit: function () {
            var params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate= that.$helper.formatDate(that.dateRange.start);
            params.toDate= that.$helper.formatDate(that.dateRange.end);
            return params;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    async viewFile(type, url, content) {
      if (type === 0) {    /* Type = 0 là dạng văn bản */
        this.isShowPopupContent = true;
        this.contentDetail = content;
      } else {
        // let that = this;
        // this.loading.value = true;
        // const data = await this.$helper.blobFileByUrl(url);
        // setTimeout(() => {
        //   that.loading.value = false;
        //   window.open(data);
        // }, 500);
        window.open(this.$helper.viewFileByUrl(url))
      }
    },
  },
  created: function () {},
  mounted() {},
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: new Date().setHours(0,0,0,0),
          end: new Date().setHours(23,59,59,999)
        }
      }
    }
  },
  computed: {},
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
